import { render, staticRenderFns } from "./fund-classification.vue?vue&type=template&id=33ba6370&"
import script from "./fund-classification.vue?vue&type=script&lang=js&"
export * from "./fund-classification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports